import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Leaf, Flame, Star, Plus } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

// Complete bowl data with matching sauces from PDF
const bowlsData = [
  { 
    id: 1, 
    name: "Buddha Bowl", 
    nameEn: "Buddha Bowl", 
    ingredients: "Basmati Reis, Kirschtomaten, gegrillte Paprika, Gurke, Hirtenkäse, Curry-Kichererbsen, Schwarzkümmel",
    ingredientsEn: "Basmati rice, Cherry tomatoes, Grilled peppers, Cucumber, Feta cheese, Curry chickpeas, Black cumin",
    price: 10.90,
    sauce: "Knoblauch-Joghurt-Creme",
    sauceEn: "Garlic Yogurt Cream",
    isVegetarian: true
  },
  { 
    id: 2, 
    name: "Rainbow Bowl", 
    nameEn: "Rainbow Bowl", 
    ingredients: "Basmati Reis, Rotkohl, Gurke, Karotte, geröstete Kidneybohnen, Mais, gegrillte Paprika, Pinienkerne",
    ingredientsEn: "Basmati rice, Red cabbage, Cucumber, Carrot, Roasted kidney beans, Corn, Grilled peppers, Pine nuts",
    price: 10.90,
    sauce: "Tahini-Zitronen-Sauce",
    sauceEn: "Tahini Lemon Sauce",
    isVegan: true
  },
  { 
    id: 3, 
    name: "Hähnchen-Sesam Bowl", 
    nameEn: "Chicken Sesame Bowl", 
    ingredients: "Basmati Reis, Hähnchenbrust, Brokkoli, Frühlingszwiebeln, Kirschtomaten, Sesam, Röstzwiebeln",
    ingredientsEn: "Basmati rice, Chicken breast, Broccoli, Spring onions, Cherry tomatoes, Sesame, Fried onions",
    price: 10.90,
    sauce: "Knoblauch-Joghurt-Creme",
    sauceEn: "Garlic Yogurt Cream",
    isPopular: true
  },
  { 
    id: 4, 
    name: "Teriyaki Bowl", 
    nameEn: "Teriyaki Bowl", 
    ingredients: "Basmati Reis, Teriyaki-Hähnchen, Avocado, Gurke, Karotte, Kirschtomaten, Sesam, Walnüsse",
    ingredientsEn: "Basmati rice, Teriyaki chicken, Avocado, Cucumber, Carrot, Cherry tomatoes, Sesame, Walnuts",
    price: 11.50,
    sauce: "Knoblauch-Joghurt-Creme",
    sauceEn: "Garlic Yogurt Cream",
    isPopular: true
  },
  { 
    id: 5, 
    name: "Garnelen Bowl", 
    nameEn: "Shrimp Bowl", 
    ingredients: "Basmati Reis, gebratene Garnelen, Brokkoli, Kirschtomaten, Gurke, Rucola, geröstete Pinienkerne",
    ingredientsEn: "Basmati rice, Pan-fried shrimp, Broccoli, Cherry tomatoes, Cucumber, Arugula, Roasted pine nuts",
    price: 13.90,
    sauce: "Senf-Dill-Creme",
    sauceEn: "Mustard Dill Cream"
  },
  { 
    id: 6, 
    name: "Love Vegan Bowl", 
    nameEn: "Love Vegan Bowl", 
    ingredients: "Basmati Reis, gebratener Tofu, Avocado, Brokkoli, Rotkohl, geröstete Cashewkerne",
    ingredientsEn: "Basmati rice, Pan-fried tofu, Avocado, Broccoli, Red cabbage, Roasted cashews",
    price: 11.50,
    sauce: "Tahini-Zitronen-Sauce",
    sauceEn: "Tahini Lemon Sauce",
    isVegan: true
  },
  { 
    id: 7, 
    name: "Korean BBQ Bowl", 
    nameEn: "Korean BBQ Bowl", 
    ingredients: "Basmati Reis, Gochujang-Hähnchenbrust, eingelegte rote Zwiebeln, Gurke, Edamame, Frühlingszwiebeln, Sesam, Mais",
    ingredientsEn: "Basmati rice, Gochujang chicken breast, Pickled red onions, Cucumber, Edamame, Spring onions, Sesame, Corn",
    price: 13.90,
    sauce: "Hanse Scharfe Mayo",
    sauceEn: "Hanse Spicy Mayo",
    isSpicy: true,
    isPopular: true
  },
  { 
    id: 8, 
    name: "Green Goddess Bowl", 
    nameEn: "Green Goddess Bowl", 
    ingredients: "Basmati Reis, Kichererbsen, Falafel, Avocado, Hummus, Kirschtomaten, Gurke, Granatapfelkerne, Minze",
    ingredientsEn: "Basmati rice, Pan-roasted chickpeas, Falafel, Avocado, Hummus, Cherry tomatoes, Cucumber, Pomegranate seeds, Mint",
    price: 12.90,
    sauce: "Tahini-Zitronen-Sauce",
    sauceEn: "Tahini Lemon Sauce",
    isVegan: true
  },
  { 
    id: 9, 
    name: "Crispy Caesar Bowl", 
    nameEn: "Crispy Caesar Bowl", 
    ingredients: "Basmati Reis, knusprige Hähnchenstreifen, Römersalat, Parmesanspäne, Croutons, Kirschtomaten, rote Zwiebel",
    ingredientsEn: "Basmati rice, Crispy chicken strips, Romaine lettuce, Parmesan shavings, Croutons, Cherry tomatoes, Red onion",
    price: 12.90,
    sauce: "Knoblauch-Joghurt-Creme",
    sauceEn: "Garlic Yogurt Cream"
  },
  { 
    id: 10, 
    name: "Hanse Burger Bowl", 
    nameEn: "Hanse Burger Bowl", 
    ingredients: "Basmati Reis, Pommes, Rinderpatty, Cheddar, Gewürzgurken, rote Zwiebel, Salat, Tomate, Röstzwiebeln",
    ingredientsEn: "Basmati rice, Fries, Beef patty, Cheddar, Pickles, Red onion, Lettuce, Tomato, Fried onions",
    price: 13.90,
    sauce: "Hanse Burger Sauce",
    sauceEn: "Hanse Burger Sauce",
    isPopular: true
  },
  { 
    id: 11, 
    name: "Hanse Salmon Bowl", 
    nameEn: "Hanse Salmon Bowl", 
    ingredients: "Basmati Reis, gegrillter Lachs, Rucola, Kirschtomaten, Gurke, rote Zwiebel, Kapern, Dill, Pinienkerne",
    ingredientsEn: "Basmati rice, Grilled salmon, Arugula, Cherry tomatoes, Cucumber, Red onion, Capers, Dill, Pine nuts",
    price: 15.90,
    sauce: "Senf-Dill-Creme",
    sauceEn: "Mustard Dill Cream",
    isPremium: true
  },
];

// Available sauces for extra
const extraSauces = [
  { name: "Knoblauch-Joghurt-Creme", nameEn: "Garlic Yogurt Cream", desc: "Cremig & mild", descEn: "Creamy & mild" },
  { name: "Tahini-Zitronen-Sauce", nameEn: "Tahini Lemon Sauce", desc: "Nussig & frisch", descEn: "Nutty & fresh", isVegan: true },
  { name: "Senf-Dill-Creme", nameEn: "Mustard Dill Cream", desc: "Würzig & aromatisch", descEn: "Spicy & aromatic" },
  { name: "Hanse Scharfe Mayo", nameEn: "Hanse Spicy Mayo", desc: "Cremig & feurig", descEn: "Creamy & fiery", isSpicy: true },
  { name: "Hanse Burger Sauce", nameEn: "Hanse Burger Sauce", desc: "Hausgemacht & würzig", descEn: "Homemade & savory" },
];

const BowlsSection = () => {
  const { language } = useLanguage();

  return (
    <section 
      id="bowls" 
      className="relative overflow-hidden"
      data-testid="bowls-section"
    >
      {/* Premium Header with Background */}
      <div className="relative py-16 md:py-20 bg-gradient-to-b from-hanse-dark via-hanse-navy to-hanse-dark">
        {/* Decorative Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-72 h-72 bg-amber-500/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 max-w-7xl relative z-10">
          {/* Section Header */}
          <div className="text-center mb-12">
            {/* Premium Badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="inline-flex items-center gap-2 mb-4 bg-gradient-to-r from-amber-500/30 to-amber-400/20 backdrop-blur-sm px-6 py-3 rounded-full border-2 border-amber-400/50 shadow-lg shadow-amber-500/20"
            >
              <Sparkles className="w-6 h-6 text-amber-400 animate-pulse" />
              <span className="text-amber-300 font-bold text-sm md:text-base uppercase tracking-wider">
                {language === 'de' ? 'Das Herz unserer Küche' : 'The Heart of Our Kitchen'}
              </span>
              <Sparkles className="w-6 h-6 text-amber-400 animate-pulse" />
            </motion.div>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4"
            >
              {language === 'de' ? 'Premium Bowls' : 'Premium Bowls'}
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-white/60 text-base md:text-lg max-w-2xl mx-auto"
            >
              {language === 'de' 
                ? 'Jede Bowl wird frisch zubereitet und mit einer passenden Signature-Sauce serviert.'
                : 'Each bowl is freshly prepared and served with a matching signature sauce.'
              }
            </motion.p>

            {/* Sauce Info Badge */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="mt-6 inline-flex items-center gap-3 bg-white/5 backdrop-blur-sm px-5 py-3 rounded-xl border border-white/10"
            >
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-amber-400 rounded-full"></div>
                <span className="text-white/70 text-sm">
                  {language === 'de' ? '1 Sauce inklusive' : '1 Sauce included'}
                </span>
              </div>
              <div className="w-px h-4 bg-white/20"></div>
              <div className="flex items-center gap-2">
                <Plus className="w-4 h-4 text-amber-400" />
                <span className="text-amber-400 text-sm font-semibold">
                  {language === 'de' ? 'Extra Sauce: +€0.60' : 'Extra Sauce: +€0.60'}
                </span>
              </div>
            </motion.div>
          </div>

          {/* Bowls Grid - 2 columns on larger screens */}
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-12">
            {bowlsData.map((bowl, index) => (
              <motion.div
                key={bowl.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className={`group relative bg-white/5 backdrop-blur-sm rounded-2xl border transition-all duration-300 hover:bg-white/8 ${
                  bowl.isPremium 
                    ? 'border-amber-400/40 hover:border-amber-400/60 shadow-lg shadow-amber-500/10' 
                    : 'border-white/10 hover:border-amber-400/30'
                }`}
              >
                {/* Premium/Popular Badges */}
                <div className="absolute -top-3 left-4 flex gap-2">
                  {bowl.isPremium && (
                    <span className="bg-gradient-to-r from-amber-500 to-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 shadow-lg">
                      <Star className="w-3 h-3" fill="currentColor" />
                      Premium
                    </span>
                  )}
                  {bowl.isPopular && !bowl.isPremium && (
                    <span className="bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 shadow-lg">
                      <Star className="w-3 h-3" fill="currentColor" />
                      {language === 'de' ? 'Beliebt' : 'Popular'}
                    </span>
                  )}
                </div>

                <div className="p-5 md:p-6">
                  {/* Bowl Header */}
                  <div className="flex justify-between items-start mb-3">
                    <div className="flex-1 pr-4">
                      <h3 className="font-heading text-lg md:text-xl font-bold text-white flex items-center gap-2 flex-wrap">
                        {language === 'de' ? bowl.name : bowl.nameEn}
                        {bowl.isVegan && <Leaf className="w-4 h-4 text-green-400" />}
                        {bowl.isVegetarian && !bowl.isVegan && <Leaf className="w-4 h-4 text-green-400/70" />}
                        {bowl.isSpicy && <Flame className="w-4 h-4 text-orange-400" />}
                      </h3>
                    </div>
                    <span className={`font-bold text-xl md:text-2xl ${bowl.isPremium ? 'text-amber-400' : 'text-amber-400'}`}>
                      €{bowl.price.toFixed(2).replace('.', ',')}
                    </span>
                  </div>

                  {/* Ingredients */}
                  <p className="text-white/50 text-sm leading-relaxed mb-4">
                    {language === 'de' ? bowl.ingredients : bowl.ingredientsEn}
                  </p>

                  {/* Sauce Section - Highlighted */}
                  <div className="bg-gradient-to-r from-amber-500/10 to-amber-600/5 rounded-xl p-3 border border-amber-400/20">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-amber-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-amber-400 text-lg">🥣</span>
                      </div>
                      <div className="flex-1">
                        <p className="text-amber-400/60 text-xs uppercase tracking-wide mb-0.5">
                          {language === 'de' ? 'Inklusive Sauce' : 'Included Sauce'}
                        </p>
                        <p className="text-amber-300 font-semibold text-sm">
                          {language === 'de' ? bowl.sauce : bowl.sauceEn}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Extra Sauces Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-white/5 to-white/3 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10"
          >
            <div className="flex flex-col md:flex-row md:items-center gap-6">
              {/* Left: Title */}
              <div className="md:w-1/3">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center">
                    <Plus className="w-6 h-6 text-amber-400" />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl font-bold text-white">
                      {language === 'de' ? 'Extra Saucen' : 'Extra Sauces'}
                    </h3>
                    <p className="text-amber-400 font-bold">+€0,60</p>
                  </div>
                </div>
                <p className="text-white/50 text-sm">
                  {language === 'de' 
                    ? 'Möchten Sie eine zusätzliche Sauce oder eine andere Sauce? Wählen Sie aus unseren Signature-Saucen.'
                    : 'Would you like an extra sauce or a different one? Choose from our signature sauces.'
                  }
                </p>
              </div>

              {/* Right: Sauce Pills */}
              <div className="md:w-2/3">
                <div className="flex flex-wrap gap-2">
                  {extraSauces.map((sauce, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, scale: 0.9 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.05 }}
                      className="bg-white/5 hover:bg-white/10 border border-white/10 hover:border-amber-400/30 rounded-xl px-4 py-3 transition-all cursor-default group"
                    >
                      <div className="flex items-center gap-2">
                        <span className="font-medium text-white group-hover:text-amber-300 text-sm transition-colors">
                          {language === 'de' ? sauce.name : sauce.nameEn}
                        </span>
                        {sauce.isVegan && <Leaf className="w-3 h-3 text-green-400" />}
                        {sauce.isSpicy && <Flame className="w-3 h-3 text-orange-400" />}
                      </div>
                      <p className="text-white/40 text-xs mt-0.5">
                        {language === 'de' ? sauce.desc : sauce.descEn}
                      </p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>

          {/* Bottom CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mt-8"
          >
            <p className="text-white/40 text-sm">
              {language === 'de' 
                ? '100% Halal • Frisch zubereitet • Premium Zutaten'
                : '100% Halal • Freshly prepared • Premium ingredients'
              }
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BowlsSection;
